<template>
    <div>

        <div class="mt-12">
            <div v-for="expert in experts" :key="expert.user_id" class="expert-card">
                <img :src="require(`@/${expert.image}`)" style="width: 100px" :alt="`${expert.name}, ${expert.title}`" :id="expert.name">
                <div class="expert-details">
                    <h3 v-html="expert.name"></h3>
                    <p><strong>Title:</strong> {{ expert.title }}</p>
                    <p><strong>Email:</strong> <a :href="'mailto:' + expert.email">{{ expert.email }}</a></p>
                    <p><strong>Phone:</strong> {{ expert.phone }}</p>
                    <!-- <p><strong>Schedule:</strong> <a :href="expert.cal_link" target="_blank">Book a meeting</a></p> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>  

    export default {
        name: 'ModuleTeam',

        components: {
        },

        props: {
            moduleDetails: Object
        },
        
        computed: {
            
        },

        mounted () {
            // console.log(this.moduleDetails)
            this.experts = this.moduleDetails.srg_team.experts
        },

        data () {
            return {
                experts: []
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .bg_pewter {
        background-color: #E9EAEC !important;
    }
    .menu_bg_primary {
        background-color: #eef7f8 !important;
    }
    .icon-size {
        width: 3rem;
    }
    .icon-size-small {
        width: 2.25rem;
    }
    .icon-size-header {
        width: 3rem;
    }
    .icon-center {
        margin: 0 auto;
    }
    .refresh_response {
        font-size: .8rem;
    }
    .click_indicator {
		width: 50px; 
		height: 3px; 
		border-top: 1px dotted rgba(0,0,0,.3);
		border-bottom: 1px dotted rgba(0,0,0,.3);
	}
    .clear_ecd {
        margin-top: 2px
    }
    .user_link {
        text-decoration: none;
    }
    .user_link:hover {
        text-decoration: underline;
    }
    .multi-service-tag {
        border-radius: 5px;
        background: #e09551; 
        font-size: 11px;
        font-weight: bold;
        color: white;
        text-align: center;
        width: 146px;
        height: 24px;
    }

    .expert-card {
      border: 1px solid #ccc;
      border-radius: 8px;
      padding: 16px;
      margin: 16px 0;
      display: flex;
      align-items: center;
      gap: 16px;
      box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    }
    .expert-card img {
      border-radius: 50%;
      width: 100px;
      height: 100px;
      object-fit: cover;
    }
    .expert-details {
      flex: 1;
    }
    .expert-details h3 {
      margin: 0;
      font-size: 1.5em;
    }
    .expert-details p {
      margin: 4px 0;
      color: #555;
    }
    .expert-details a {
      color: #007bff;
      text-decoration: none;
    }
    .expert-details a:hover {
      text-decoration: underline;
    }
</style>


// WEBPACK FOOTER //
// src/components/ModuleTeam.vue